
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SliderToggle',
    components: {
    },
    props: {
        toggle: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:toggle'],
    computed: {
        toggleData: {
            get() {
                return this.toggle
            },
            set(value: boolean) {
                this.$emit('update:toggle', value)
            }
        }
    }
});
